/*********** PRODUCT DESCRIPTION READ MORE ***********/

$(document).ready(function($){
  $('.product__description').find('p').first().addClass('first_para');

  if($('.first_para').outerHeight()+20 < 182){
    $('.product__description').height($('.first_para').outerHeight()+20)
  } else {
    $('.product__description').height(182);
  }
  


  $('.readmore').insertAfter( '.product__description' );

  $('.readmore').click(function (event) {
    event.preventDefault();
    var description = document.querySelector('.product__description');

    console.log($('.first_para').height());
    if (description.style.height === ''){
      description.style.height = 'auto';
    } else if (description.style.height === 'auto'){
//      description.style.height = '';
      if($('.first_para').outerHeight()+20 < 182){
      	$('.product__description').height($('.first_para').outerHeight()+20)
      } else {
        $('.product__description').height(182);
      }
    }
    else{
      description.style.height = 'auto';
    }

    $(this).html($(this).html() == '<span><i class="fas fa-chevron-up"></i></span> read less' ? '<span><i class="fas fa-chevron-down"></i></span> Click here for size and more info' : '<span><i class="fas fa-chevron-up"></i></span> read less');
  });
});
$(document).ready(function($){
  $('.delivery-link a').click(function(e){
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $("#delivery-info").offset().top
    }, 1000);
  });
});


/*********** DELIVERY SCROLL ***********/

$(document).ready(function($){
  $('.delivery-link a').click(function(e){
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $(".delivery-info").offset().top
    }, 1000);
  });
});


/*********** FITTING BOX ***********/

let fitmixInstance;


  // Get the modal
  var modal = document.getElementById("myModal");
  
  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];
  
  var shape_val;
  var colour_val;
  
  var fittingbox_frame;
  
  
  
  var params = {
    apiKey: 'n2Fv2anxIdXDJKTk9d9R3fjIIzpBT32eKmrj8wWT', // replace by your apiKey (see Requirements)
    onSnapshot: onSnapshot,
    onStopVto : () => { fitmix.style.display = 'none'; },
  };
   
  fitmixInstance = FitMix.createWidget(
      'fitmix-container',
      params
    );

  



  function hideVto() {
    fitmixInstance.stopVto();
  }
  
  function showVto() {
    fitmixInstance.startVto('live');
  }

// When the user clicks the button, open the modal  
function openModal(frame,handle,id,price,shape,colour) {

  
  $("#myModal").css('display','block');

  showVto();
  
  $('#pupile').val('');

  shape_val = shape.substring(0, shape.length - 2);
  colour_val = colour.substring(0, colour.length - 2);

  console.log('shape_val '+shape_val);
  console.log('colour_val '+colour_val);



  fittingbox_frame = frame;
  selectFrame(frame,handle,id,price,shape,colour);
  jQuery('.pp_dist').show();
}

function set_size(dist){
  console.log('dist '+dist);
  fitmixInstance.setUserInfo({});
  fitmixInstance.setPupillaryDistance(parseInt(dist)); // pupillary distance in millimeters
  fitmixInstance.setFrame(fittingbox_frame);
  jQuery('.pp_dist').hide();
}

function set_gender(dist){
  fitmixInstance.setPupillaryDistance();
  fitmixInstance.setUserInfo({gender: dist}); // female user // pupillary distance in millimeters
  fitmixInstance.setFrame(fittingbox_frame);
  jQuery('.pp_dist').hide();
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  fitmixInstance.stopVto();
  modal.style.display = "none";
  //document.getElementById('fitmix-container').innerHTML = "";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
    //document.getElementById('fitmix-container').innerHTML = "";
  }
}



function onSnapshot(data) {
  var img = document.getElementById("my-snapshot");
  jQuery('#my-snapshot').attr("src", data.dataURL).show();
  jQuery('.takeshot').show();
  jQuery('.snapshot').hide();
}


function getSnapshot() {
  fitmixInstance.getSnapshot();
}

var selectFrame = function(frame,handle,id,price,shape,colour) {


  form_id = id;

  shape = shape.substring(0, shape.length - 2);
  colour = colour.substring(0, colour.length - 2);

  shape = shape.split('__');
  colour = colour.split('__');

  console.log('handle '+handle);
  console.log('shape '+shape);
  console.log('colour '+colour);

  jQuery('.frame_button').hide();

  for (let i = 0; i < shape.length; i++) {
    for (let j = 0; j < colour.length; j++) {
      console.log('MATCHING FRAME .frame_button.'+ shape[i] + '.'+colour[j]);



      jQuery('.frame_button.'+ shape[i] + '.'+colour[j]).show();
    }
  }


  jQuery.getJSON('/products/'+handle+'.js', function(product) {   
    jQuery(".modal_col_left .page-title").html(product.title);        	
    jQuery(".modal_col_right .page-title").html(product.title);
    jQuery(".modal_col_right .product-price-minimum").html(price);
    jQuery(".modal_col_right .vm-product-url").attr("href",product.url);
    jQuery(".modal_col_right .vm-product-description").html(product.description);

  } );


  fitmixInstance.setFrame(frame);

};


function takeshot() {
  var img_src = jQuery('#my-snapshot').attr('src');

  var frames = jQuery('#page-title').html();

  watermark([img_src])
  .image(watermark.text.upperLeft('www.retropeepers.com', '30px PT Mono', '#9f0004', 1, 30, 30))
  .render()
  .image(watermark.text.lowerRight(frames, '20px PT Mono', '#9f0004', 1))
  .then(function (img) {
    var a = document.createElement("a"); //Create <a>
    a.href = img.src; //Image Base64 Goes here
    a.download = frames.replace(/ /g,"_")+".png"; //File name Here
    a.click(); //Downloaded file
  });

  jQuery('#my-snapshot').attr("src", "").hide();
  jQuery('.takeshot').hide();
  jQuery('.snapshot').show();
}

function deleteshot() {
  jQuery('#my-snapshot').attr("src", "").hide();
  jQuery('.takeshot').hide();
  jQuery('.snapshot').show();
}


function share_image() {

  var img_src = jQuery('#my-snapshot').attr('src');

  var frames = jQuery('#page-title').html();

  watermark([img_src])
  .image(watermark.text.upperLeft('https://retropeepers.com', '24px PT Mono', '#000000', 0.8))
  .render()
  .image(watermark.text.lowerRight(frames, '14px PT Mono', '#000000', 0.8))
  .then(function (img) {
    var a = document.createElement("a"); //Create <a>
    a.href = img.src; //Image Base64 Goes here
    a.download = frames.replace(/ /g,"_")+".png"; //File name Here
    u = a.download;
    t = frames;
    window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(u)+'&t='+encodeURIComponent(t),'sharer','toolbar=0,status=0,width=626,height=436');return false;
  });


}



var waitForJQuery = setInterval(function () {
  if (typeof $ != 'undefined') {

    $('.vm_active').show();

    $('.pp_vm select').on('click', function(){
      //      	console.log('hehehe');
    })

    clearInterval(waitForJQuery);
  }
}, 10);


var results;
var fallbackURL = $(".collection-filtering").data("fallback-url");

$('.collection-filtering select').on('change', function(){
  changeFilter();
  updateFilter($(this));
  console.log($('.collection-sorting select').val());
})

$('.collection-remove-filter').on('click', function(){
  resetFilter();
})



function changeFilter(){                           
  var filter, j, len, ref1, selectedText;
  var fallbackURL = $(".collection-filtering").data("fallback-url");
  ref1 = $(".collection-filter select");
  results = [];
  for (j = 0, len = ref1.length; j < len; j++) {
    filter = ref1[j];
    if ($(filter).val() !== "any") {
      selectedText = $(filter).find("option:selected").text();
      console.log(selectedText);
      results.push($(filter).prev().find("strong").text(selectedText));
    } else {
      results.push(void 0);
    }
  }

  console.log(results);
}

changeFilter();

function updateFilter(e){
  var filter, filterURL, j, len, newTags, ref1, tag, tags;
  newTags = [];
  e.toggleClass("active");
  ref1 = $(".collection-filter select");
  for (j = 0, len = ref1.length; j < len; j++) {
    filter = ref1[j];
    if ($(filter).val() !== "any") {
      tag = $(filter).val();
      newTags.push(tag);
    }
  }
  if (newTags.length) {
    console.log()
    tags = newTags.join("+");
    filterURL = this.fallbackURL + "/" + tags;

    if (window.location.href.indexOf("?&sort_by=") > -1) {
      window.location.href = filterURL+'?&sort_by='+$('.collection-sorting select').val();
    } else {      
      window.location.href = filterURL;
    }

  } else {
    resetFilter();
  }

}

function resetFilter() {
  var fallback;
  fallback = "" + fallbackURL;
  
  if (window.location.href.indexOf("?&sort_by=") > -1) {
      window.location.href = fallback+'?&sort_by='+$('.collection-sorting select').val();
    } else {      
      window.location.href = fallback;
    }

};

/*********** OMNISEND RATINGS ***********/

function omnisendHide() {
  
  console.log('loaded');
  
  var reviewElement = document.querySelector(".omnisend-main-review-block-average-rating-description");

  if(!reviewElement) {
    return;
  }

  console.log('reviewElement.innerText '+reviewElement.innerText);
  
  if(reviewElement.innerText === 'Based on 0 reviews'){
    document.getElementById("omnisend-reviews-block").style.display = 'none';
  }
  
}

setTimeout(() => {
  omnisendHide();
}, "1000");


